// export const SERVER = "http://0.0.0.0:8000"

export const SERVER = "https://iretro.onrender.com" 

// If you wish to compose using Docker, please disable line 3 and comment line no. 1. 

export let webColor = "rgb(128, 95, 75)"